import * as React from 'react';
import InfiniteCalendar, { Calendar, withRange } from 'react-infinite-calendar';
import { addDays } from 'date-fns';
import 'react-infinite-calendar/styles.css'; // Make sure to import the default stylesheet
import { DateRange } from './types';

interface DatePickerProps {
  selected: DateRange;
  onSelect({ start, end }: { start: Date; end: Date });
}

const CalendarWithRange = withRange(Calendar);

export const DatePicker = (props: DatePickerProps) => {
  const maxDate = addDays(new Date(), 1);

  return (
    <InfiniteCalendar
      onSelect={props.onSelect}
      Component={CalendarWithRange}
      width={'100%'}
      displayOptions={{
        showHeader: false,
        showTodayHelper: false,
      }}
      maxDate={maxDate}
      theme={{
        weekdayColor: '#fff',
        textColor: {
          active: '#5B5B65',
          default: '#333',
        },
        accentColor: '#3023AE',
        todayColor: '#3023AE',
        selectionColor: 'rgba(48, 35, 174, 0.1)',
      }}
      selected={props.selected}
    />
  );
};
